"use client"

import React from "react"
import { XCircleIcon } from "lucide-react"
import { useTranslations } from "next-intl"

import { UserData } from "@/lib/intershop/interfaces/user/user"
import { ExtendedAddressRO } from "@/lib/storefront/addresses/address"
import { cn } from "@/components/ui/helpers/utils"
import EditOrCreateAddress from "@/components/common/addresses/EditOrCreateAddress"

interface AddressEditModalProps {
  visible: boolean
  address: any
  customer: any
  user: any
  onSave?: (a: ExtendedAddressRO, u: UserData) => void
  onCancel: () => void
  mode: "add" | "edit"
}

export default function AddressEditModal({
  visible,
  address,
  customer,
  user,
  onSave,
  onCancel,
  mode,
}: AddressEditModalProps) {
  const t = useTranslations("storefront")

  return (
    <div
      className={cn("fixed left-0 top-0 z-modal-level hidden h-screen w-screen bg-black/30", {
        block: visible,
      })}
    >
      <div className="bg-muted absolute bottom-0 top-0 rounded-sm md:bottom-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2">
        <div className="p-1 md:p-6 md:pt-14">
          <h2 className="text-lg font-bold mb-4">
            {mode === "add" ? t("forms.edit_address_form.add") : t("forms.edit_address_form.edit")}
          </h2>
          <EditOrCreateAddress
            address={address}
            customer={customer}
            user={user}
            onSave={onSave}
            mode={mode}
            type={"general"}
            validateOnFirstRender={false}
          />
        </div>
        <button className="group absolute right-3 top-3" onClick={onCancel}>
          <XCircleIcon className={"size-8 group-hover:text-primary"} />
        </button>
      </div>
    </div>
  )
}
